// extracted by mini-css-extract-plugin
export default {"scroll":"table_scroll__rE8hg","warehouseRow":"table_warehouseRow__tLRIL"};